/**
 * tw-slideshow - Custom slideshow with autoplay and navigation
 */
(function() {
  function initTwSlideshow(section) {
    if (!section) return;

    var list = section.querySelector('[data-tw-slideshow-list]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-tw-slide]'));
    var prevBtn = section.querySelector('[data-tw-slide-prev]');
    var nextBtn = section.querySelector('[data-tw-slide-next]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-tw-dot]'));

    if (!list || slides.length <= 1) return;

    var total = slides.length;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    console.log('[TW-Slideshow] Autoplay config:', { autoplay: autoplay, speed: speed, attr: section.getAttribute('data-autoplay'), dataset: section.dataset });
    var timer = null;
    var isPaused = false;

    function updateDots() {
      dots.forEach(function(btn, i) {
        btn.setAttribute('aria-current', i === index ? 'slide' : 'false');
      });
    }

    function goTo(i, animate) {
      if (typeof animate === 'undefined') animate = true;
      index = (i + total) % total;

      if (!animate) {
        list.style.transition = 'none';
        list.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        list.offsetHeight;
        list.style.transition = '';
      } else {
        list.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
      }
      updateDots();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || isPaused) return;
      timer = setInterval(next, speed);
    }

    function restartAutoplay() {
      startAutoplay();
    }

    function handleMouseEnter() {
      isPaused = true;
      stopAutoplay();
    }

    function handleMouseLeave() {
      isPaused = false;
      startAutoplay();
    }

    function handleVisibility() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        prev();
        restartAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        next();
        restartAutoplay();
      });
    }

    dots.forEach(function(btn, i) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        goTo(i);
        restartAutoplay();
      });
    });

    section.addEventListener('mouseenter', handleMouseEnter);
    section.addEventListener('mouseleave', handleMouseLeave);
    section.addEventListener('focusin', handleMouseEnter);
    section.addEventListener('focusout', handleMouseLeave);
    document.addEventListener('visibilitychange', handleVisibility);

    goTo(0, false);
    startAutoplay();

    section._twSlideshow = {
      destroy: function() {
        stopAutoplay();
        if (prevBtn) prevBtn.removeEventListener('click', prevBtn._twPrevHandler);
        if (nextBtn) nextBtn.removeEventListener('click', nextBtn._twNextHandler);
        dots.forEach(function(btn) {
          if (btn._twDotHandler) btn.removeEventListener('click', btn._twDotHandler);
        });
        section.removeEventListener('mouseenter', handleMouseEnter);
        section.removeEventListener('mouseleave', handleMouseLeave);
        section.removeEventListener('focusin', handleMouseEnter);
        section.removeEventListener('focusout', handleMouseLeave);
        document.removeEventListener('visibilitychange', handleVisibility);
      }
    };
  }

  function initAllSlideshows(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tw-slideshow]').forEach(function(section) {
      initTwSlideshow(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllSlideshows(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.matches('[data-tw-slideshow]')
      ? e.target
      : e.target.querySelector('[data-tw-slideshow]');
    if (section) initTwSlideshow(section);
  });

  document.addEventListener('shopify:section:reorder', function() {
    initAllSlideshows(document);
  });

  document.addEventListener('shopify:block:select', function(e) {
    var slide = e.target.closest('[data-tw-slide]');
    var section = e.target.closest('[data-tw-slideshow]');
    if (!slide || !section) return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-tw-slide]'));
    var idx = slides.indexOf(slide);
    if (idx > -1 && section._twSlideshow) {
      var list = section.querySelector('[data-tw-slideshow-list]');
      list.style.transform = 'translate3d(-' + (idx * 100) + '%, 0, 0)';
      section.querySelectorAll('[data-tw-dot]').forEach(function(btn, i) {
        btn.setAttribute('aria-current', i === idx ? 'slide' : 'false');
      });
    }
  });
})();